import React from 'react';
import StationBatchModal from './StationBatchModal';

function StationTooltip({ station, position, scale = 1, batchData = [] }) {
  // Show batch modal for all stations
  return (
    <StationBatchModal
      station={station}
      position={position}
      isTooltip={true}
      batchData={batchData}
    />
  );
}

export default StationTooltip;
